/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { WorkbookId } from "../../commons/types/WorkbookId";
export const GuestWorkbook = core.serialization.object({
    id: WorkbookId,
});
